import {REDUX_SET} from './constants';

const DEFAULT_STATE = {
  visible: false,
};

export default (state = DEFAULT_STATE, {type, data}) => {
  switch (type) {
    case REDUX_SET:
      return {
        ...state,
        ...data,
      };

    default:
      return state;
  }
};
